import { createRouter } from "@tanstack/react-router";
import { routeTree } from "../routeTree.gen";
import { AuthState } from "./use-auth";

type RouterContext = {
  authState: AuthState;
};

const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  context: {
    authState: { state: "PENDING" },
  },
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

export { router };
export type { RouterContext };
